import { FormGroup, Validators } from '@angular/forms';

import { FormObjects } from '../../../../../shared/core/utilities/formObjects';
import { NdmsUtils } from '../../../../../shared/core/utilities/ndmsUtils';
import { LookupModel } from '../../../api/models/lookup-model';
import { BaseFormViewModel } from '../../../../../shared/ui-ndms/view-models/base-form.view-model';
import { JpatsFormObjects } from '../../core-jpats/utilities/jpatsFormObjects';
import { NdmsValidators } from '../../../../../shared/ui-ndms/forms/ndmsValidators.validators';

export class PatientIdentifierViewModel extends BaseFormViewModel{
    identifierNumber?: string=undefined;
    key?: string=undefined;
    patientKey?: string=undefined;
    metadataKey?: string= undefined;
    hashCode?: number =0;
    identifierType?: LookupModel= undefined;
    autoGenerate: boolean = false;
    constructor(initializer?: any) {
        super();
        NdmsUtils.initObj(this, initializer);
    }

    toFormGroup(existingFormGroup?: FormGroup): FormGroup {
        let formGroupConfig = {

            identifierNumber: FormObjects.String(this.identifierNumber, [NdmsValidators.noSpace]),

            hashCode: FormObjects.Number(this.hashCode),
            autoGenerate: FormObjects.Boolean(this.autoGenerate)
        };
        let newFormGroup = new FormGroup(formGroupConfig);
        return existingFormGroup || newFormGroup;
    }

    static fromFormGroup(formModel: any): PatientIdentifierViewModel{
        let patientIdentifierViewModel:any = {
          identifierNumber: formModel.identifierNumber,
          patientKey: formModel.patientKey,
          hashCode: formModel.hashCode,
          autoGenerate: formModel.autoGenerate
        };
        return patientIdentifierViewModel;
    }

}
